import React from "react";
import { defineMessages, useIntl, FormattedMessage } from "react-intl";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { useHistory } from "react-router-dom";
import { Chip } from "@material-ui/core";
import { WorkOrderStatusIcon } from "../common/icons/workOrderStatusIconHelper";
import { getDayString, getTimeRangeBtw } from "./jobUtility";
import { useLocalizedName, getlabourerTaskStatus } from "../../globals/langHelpers";
import "./styles.css";

const messages = defineMessages({
    emergencyPriorityLabel: {
        id: "tech.job.emergency-label",
        defaultMessage: "Emergency",
        description: "label indicating emergency priority of job",
    },
    highPriorityLabel: {
        id: "tech.job.high-label",
        defaultMessage: "High",
        description: "label indicating high priority of job",
    },
});
export default function Job(props) {
    const BSW_Activity = {
        nameEn: "Buried Service Wire",
        nameFr: "Fils de Service Enfoui",
    };
    const PLACE_CABLE = {
        nameEn: "Place Cable - Buried (Bell cable tech use only)",
        nameFr: "Placer le câble - Enfouis (Réservé aux techniciens des câbles Bell)",
    };
    const { data } = props;
    const history = useHistory();
    const intl = useIntl();
    const { getLocalizedName } = useLocalizedName();

    return (
        <div>
            <Paper elevation={3}>
                <Grid container spacing={2} className="job-card-grid" onClick={() => history.push("/workorderdetails/" + data.FK_workOrderNumber)}>
                    <Grid item xs={3} sm={2} md={1} container direction="column" alignItems="center">
                        <div>
                            <WorkOrderStatusIcon id={data.status.id} />
                        </div>
                        <div className="job-status-text"> {getlabourerTaskStatus(intl, data.status)}</div>
                    </Grid>
                    <Grid item xs={9} sm={10} md={11}>
                        <div className="wo-heading">{"WO #" + data.FK_workOrderNumber}</div>
                        <div className="job-address">{data.address + ", " + data.municipality}</div>
                        <div className="job-work-type">{getLocalizedName({ object: data.workType })}</div>
                        <div className="job-work-details">
                            {data.FK_workActivity === 296
                                ? getLocalizedName({ object: BSW_Activity })
                                : data.FK_workActivity === 299
                                ? getLocalizedName({ object: PLACE_CABLE })
                                : getLocalizedName({ object: data.workActivity })}
                        </div>
                        <div className="job-indicators">
                            {data.doubleLidded && (
                                <div className="double-lidded">
                                    <FormattedMessage
                                        id="tech.job.double-lidded"
                                        defaultMessage="DOUBLE LIDDED"
                                        description="Notification declaring that job is double lidded"
                                    />
                                </div>
                            )}
                            {/* traffic control requried change here */}
                            {data.trafficControlRequired && (
                                <div className="traffic-control-req">
                                    <FormattedMessage
                                        id="tech.job.traffic-control-required"
                                        defaultMessage="TRAFFIC CONTROL REQ'D"
                                        description="Notification declaring that the traffic control is required"
                                    />
                                </div>
                            )}
                        </div>
                        <div className="time-priority-container">
                            <div className="job-time-duration">
                                <span className="job-day">
                                    {/*{getDayString(data.taskAssignedDate)}*/}
                                    {getDayString(data.scheduledDate)}
                                </span>
                                {/*<span className='job-duration'>{getTimeRange(data.taskAssignedDate, data.duration)}</span>*/}
                                <span className="job-duration">{getTimeRangeBtw(data.scheduledDate, data.duration)}</span>
                            </div>
                            <div>
                                {data.priority.id === 2 && (
                                    <Chip
                                        size="small"
                                        color="primary"
                                        style={{ backgroundColor: "#FF4500" }}
                                        label={intl.formatMessage(messages.highPriorityLabel)}></Chip>
                                )}
                                {data.priority.id === 1 && (
                                    <Chip size="small" color="secondary" label={intl.formatMessage(messages.emergencyPriorityLabel)}></Chip>
                                )}
                                {![1, 2].includes(data.priority.id) && (
                                    <Chip size="small" variant="outlined" label={getLocalizedName({ object: data.priority })}></Chip>
                                )}
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </Paper>
        </div>
    );
}
